<main libAppTenant class="main">
  <lib-header>
    <lib-breadcrumb
      slot="breadcrumb"
      *ngIf="mostrarPasos && tenant"
      [pasoActual]="pasoActual"
      [pasos]="pasos"
      [ocultarEnMobile]="false"
    >
    </lib-breadcrumb>
    <ng-container slot="menuRef">
      <div class="sub-menu"></div>
    </ng-container>
  </lib-header>
  <div class="flex-grow-1">
    <router-outlet></router-outlet>
  </div>
  <app-footer></app-footer>
  <sura-loading-screen
    [isLoading]="(suraLoadingService.tags | async)?.length"
  ></sura-loading-screen>
  <lib-chatbot-tibot [show]="showChatBot" [urlIcon]="urlIconChatBot">
  </lib-chatbot-tibot>
</main>
